// Barrel re-export — backward-compatible with `import { colors } from '../theme'`
export { lightPalette as colors } from './palettes';
export { spacing, radius, shadows, typography, rawColors } from './tokens';
export { lightPalette, darkPalette } from './palettes';
export type { ThemeMode, ThemePalette, Theme } from './types';

// Status color maps
import { lightPalette } from './palettes';

export const ACTIVITY_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  todo: lightPalette.todo,
  'in-progress': lightPalette['in-progress'],
  done: lightPalette.done,
  skipped: lightPalette.skipped,
};

export const GOAL_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  planned: lightPalette.planned,
  active: lightPalette.active,
  completed: lightPalette.completed,
  paused: lightPalette.paused,
};
